import { ColDef } from 'ag-grid-community';
import BalanceGridRow, { AssetType } from '../types';
import { format } from 'erisxkit/client';
import get from 'lodash/get';
import find from 'lodash/find';

const createAssetTypeColDef = (
  assetType: AssetType,
): ColDef<BalanceGridRow> => {
  const symbol = assetType?.symbol || '';
  return {
    headerName: symbol,
    colId: symbol,
    filter: false,
    initialWidth: 120,
    sortable: false,
    valueFormatter: ({ data }) =>
      format(
        get(
          find(data?.balancesUSD, { assetType: symbol?.toUpperCase() }),
          'amount',
          0,
        ),
        {},
      ),
  };
};

export default createAssetTypeColDef;
